// removed by extract-text-webpack-plugin
module.exports = {"heading":"sectionDescription-module_heading_1ZBbM","centralHeading":"sectionDescription-module_centralHeading_Q9bFG sectionDescription-module_heading_1ZBbM","centralBody":"sectionDescription-module_centralBody_2X9-n","centralSection":"sectionDescription-module_centralSection_1-A2Q","hideOnMobile":"sectionDescription-module_hideOnMobile_1B1h5"};


//////////////////
// WEBPACK FOOTER
// ./client/pages/home/sectionDescription/sectionDescription.module.css
// module id = 460
// module chunks = 1 3